import React, { Component } from "react";
import { Card, Col, Container, Badge, Row, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";

export default class ZunoKycresponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chpiId: sessionStorage.getItem("chpiId"),
      proposalId: sessionStorage.getItem("proposalId"),
      proposalNum: sessionStorage.getItem("proposalNum"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      cqrId: sessionStorage.getItem("cqrId"),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      zuno_totalAmount: sessionStorage.getItem("totalAmount"),
      policyuuid: sessionStorage.getItem("policyId"),
      kycLeadId: sessionStorage.getItem("currentLeadId"),
      kycjsondata: sessionStorage.getItem("kycjsondata"),
      policieskyc: [],
      startDate: new Date(),
      responseData: null,
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  componentDidMount() {
    this.handleSubmitClick();
  }
  handleSubmitClick = (e) => {
    const kycData = JSON.parse(sessionStorage.getItem("kycjsondata")) || {};
    const leadId = kycData.leadId || "";
    const idType = kycData.kycId?.idType || "";
    const idNumber = kycData.kycId?.idNumber || "";
    const dob = kycData.proposer?.dobDoi || "";
    const email = kycData.proposer?.email || "";
    const gender = kycData.proposer?.gender || "";
    const mobileNum = kycData.proposer?.mobileNum || "";
    const name = kycData.proposer?.name || "";
    const jsonData = {
      source: "ApnaPolicyHealth",
      leadId: leadId,
      kycId: {
        idType,
        idNumber,
      },
      proposer: {
        dobDoi: dob,
        email,
        gender,
        mobileNum,
        name,
        proposerType: "I",
      },
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 354);
    formData.append("savedata", "yes");
    formData.append("jsonData", jsonData1);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponsejsonfetchHandler();
          }, 10000);
        }
      });
  };
  ResponsejsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 354);
    formData.append("requestId", sessionRequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ responseData: data.data.data });
        }
      })
      .catch((err) => {
        console.error("Failed to fetch response JSON:", err);
        this.showToast("Unable to load premium details", "error");
      });
  };
  renderCardContent = () => {
    const { responseData } = this.state;
    if (!responseData) {
      return <p className="text-muted">⏳ Loading KYC details...</p>;
    }

    const { verified, kycInfo, kycQueryParams, meta } = responseData;

    return (
      <div>
        <h5>
          Status:{" "}
          {verified ? (
            <Badge bg="success">✅ Verified</Badge>
          ) : (
            <Badge bg="warning" text="dark">
              ⏳ Not Completed
            </Badge>
          )}
        </h5>
        <hr />
        {verified && (
          <p>
            <strong className="text-primary">Full Name:</strong>{" "}
            <span className="text-dark">{kycInfo?.proposerName?.fullName}</span>
          </p>
        )}
        <p>
          <strong className="text-success">Lead ID:</strong>{" "}
          <span className="text-dark">{kycQueryParams?.leadId}</span>
        </p>
        <p>
          <strong className="text-info">Zuno KYC No:</strong>{" "}
          <span className="text-dark">{kycQueryParams?.zunoKycNo}</span>
        </p>
        <p>
          <strong className="text-danger">Remarks:</strong>{" "}
          <em className="text-secondary">{meta?.remarks}</em>
        </p>
      </div>
    );
  };
  handleButtonClick = () => {
    const amount = sessionStorage.getItem("totalAmount");
    const policyId = sessionStorage.getItem("policyId");
    window.location.href =
      configData.api_url +
      `payments/zunopayments?amount=${amount}&policyId=${policyId}`;
    // window.location.href =
    //   configData.api_url +
    //   "payments/zunopayments?amount=1000&policyId=6128058a-3ff6-4e38-b712-9ed1b8d1d52e";
  };
  render() {
    return (
      <div>
        <Container className="mt-4">
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Card className="shadow-lg border-0 rounded-3">
                <Card.Header className="bg-primary text-white">
                  <h5 className="mb-0">📋 Zuno KYC Response</h5>
                </Card.Header>
                <Card.Body>{this.renderCardContent()}</Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <Button
                style={{ float: "right" }}
                type="button"
                onClick={this.handleButtonClick}
              >
                Pay {this.state.zuno_totalAmount}/-
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
